import { ApolloClient, gql } from '@apollo/client';

export interface PutInsightsFeedbackVars {
  domainIdentuple: string;
  resourceType: string;
  usecases: object;
  overrideBy: string;
}

const PUT_INSIGHTS_FEEDBACK = gql`
  query PutInsightsFeedback(
    $domainIdentuple: String,
    $resourceType: String,
    $usecases: JSON,
    $overrideBy: String,
  ) {
    putInsightsFeedback(
      domainIdentuple: $domainIdentuple,
      resourceType: $resourceType,
      usecases: $usecases,
      overrideBy: $overrideBy,
    )
  }
`;

export async function putInsightsFeedback(
  client: ApolloClient<object>,
  variables: PutInsightsFeedbackVars,
): Promise<any> {
  const { data, errors } = await client.mutate<any, PutInsightsFeedbackVars>({
    mutation: PUT_INSIGHTS_FEEDBACK,
    variables,
    errorPolicy: 'all',
  });

  if (errors && errors.length > 0) {
    throw new Error(errors[0].message || 'Failed to submit feedback');
  }

  return data;
}
